function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { SET_PLUGINS, SET_USER, SET_WORKSPACE, SET_COMMAND_HISTORY_STORAGE, SET_WORKSPACE_STORAGE, SET_ACTIVE_TOOL, SET_FILE_STORAGE, SET_SERVER_CONFIG_VALUES, SET_API, SET_DEFAULT_WORKSPACE_SETTINGS } from "./actionTypes.js";
import { getSettings } from "./selectors.js";
export var setUser = user => ({
  type: SET_USER,
  payload: user
});
export var setApi = api => ({
  type: SET_API,
  payload: api
});
export var setWorkspace = workspace => ({
  type: SET_WORKSPACE,
  payload: workspace
});
export var setDefaultWorkspaceSettings = settings => ({
  type: SET_DEFAULT_WORKSPACE_SETTINGS,
  payload: settings
});
export var setWorkspaceStorage = workspaceStorage => ({
  type: SET_WORKSPACE_STORAGE,
  payload: workspaceStorage
});
export var setCommandHistoryStorage = commandHistoryStorage => ({
  type: SET_COMMAND_HISTORY_STORAGE,
  payload: commandHistoryStorage
});
export var setFileStorage = fileStorage => ({
  type: SET_FILE_STORAGE,
  payload: fileStorage
});

/**
 * Sets the specified workspace locally and saves it remotely
 * @param workspace The workspace to save
 */
export var saveWorkspace = workspace => (dispatch, getState) => {
  dispatch(setWorkspace(workspace));
  var _getState = getState(),
    storage = _getState.storage;
  var workspaceStorage = storage.workspaceStorage;
  return workspaceStorage === null || workspaceStorage === void 0 ? void 0 : workspaceStorage.save(workspace);
};

/**
 * Update part of the workspace data and save it
 * @param workspaceData The properties to update in workspace data
 */
export var updateWorkspaceData = workspaceData => (dispatch, getState) => {
  var _getState2 = getState(),
    workspace = _getState2.workspace;
  var _ref = workspace !== null && workspace !== void 0 ? workspace : {},
    data = _ref.data;
  var newWorkspace = _objectSpread(_objectSpread({}, workspace), {}, {
    data: _objectSpread(_objectSpread(_objectSpread({}, data), workspaceData), {}, {
      settings: _objectSpread(_objectSpread({}, data === null || data === void 0 ? void 0 : data.settings), workspaceData.settings)
    })
  });
  return dispatch(saveWorkspace(newWorkspace));
};
export var updateNotebookSettings = settings => (dispatch, getState) => {
  var _getSettings = getSettings(getState()),
    notebookSettings = _getSettings.notebookSettings;
  var newNotebookSettings = _objectSpread(_objectSpread({}, notebookSettings), settings);
  return dispatch(updateSettings({
    notebookSettings: newNotebookSettings
  }));
};

/**
 * Sets the specified settings locally and saves them remotely
 * @param settings The settings to save
 */
export var updateSettings = settings => dispatch => dispatch(updateWorkspaceData({
  settings
}));
export var setActiveTool = payload => ({
  type: SET_ACTIVE_TOOL,
  payload
});
export var setPlugins = plugins => ({
  type: SET_PLUGINS,
  payload: plugins
});
export var setServerConfigValues = config => ({
  type: SET_SERVER_CONFIG_VALUES,
  payload: config
});
//# sourceMappingURL=actions.js.map